__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-8467f4c4/_next/";